<template>
  <div class="about">
    <AppHeader />
    <h1>This is an about page</h1>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";

export default {
  components: {
    AppHeader
  }
};
</script>
